(function () {

function initDragVS() {
    const chat = document.getElementById("ShopifyChat");
    if (!chat) return false;

    if (chat.dataset.dragReady) return true;
    chat.dataset.dragReady = "1";

    let dragging = false;
    let moved = false;
    let offsetX = 0;
    let offsetY = 0;

    let lastLeft = 20;
    let lastTop = window.innerHeight * 0.8;

    chat.style.position = "fixed";
    chat.style.left = lastLeft + "px";
    chat.style.top = lastTop + "px";
    chat.style.right = "auto";
    chat.style.bottom = "auto";
    chat.style.zIndex = "999999";
    chat.style.touchAction = "none";

    function isOpen() {
        return chat.getAttribute("is-open") === "true";
    }

    function applyOpenMode() {
        chat.style.transition = "all 0.18s ease-out";
        chat.style.left = "0px";
        chat.style.top = "0px";
        chat.style.right = "auto";
        chat.style.bottom = "auto";
    }

    function applyClosedMode() {
        chat.style.transition = "all 0.18s ease-out";
        chat.style.left = lastLeft + "px";
        chat.style.top = lastTop + "px";
        chat.style.right = "auto";
        chat.style.bottom = "auto";
    }

    function start(x, y) {
        if (isOpen()) return;

        dragging = true;
        moved = false;

        offsetX = x - chat.offsetLeft;
        offsetY = y - chat.offsetTop;

        chat.style.transition = "none";
    }

    function move(x, y) {
        if (!dragging) return;

        moved = true;

        let newLeft = x - offsetX;
        let newTop = y - offsetY;

        const maxX = window.innerWidth - chat.offsetWidth;
        const maxY = window.innerHeight - chat.offsetHeight;

        if (newLeft < 0) newLeft = 0;
        if (newLeft > maxX) newLeft = maxX;

        if (newTop < 0) newTop = 0;
        if (newTop > maxY) newTop = maxY;

        chat.style.left = newLeft + "px";
        chat.style.top = newTop + "px";
    }

    function snapToEdge() {
        const maxX = window.innerWidth - chat.offsetWidth;
        const currentLeft = chat.offsetLeft;

        lastLeft =
            currentLeft < window.innerWidth / 2 ? 10 : maxX - 10;

        lastTop = chat.offsetTop;

        chat.style.transition = "left 0.18s ease-out, top 0.18s ease-out";
        chat.style.left = lastLeft + "px";
        chat.style.top = lastTop + "px";
    }

    function end() {
        if (!dragging) return;

        dragging = false;

        if (moved) snapToEdge();
    }

    chat.addEventListener("mousedown", function (e) {
        start(e.clientX, e.clientY);
    });

    document.addEventListener("mousemove", function (e) {
        move(e.clientX, e.clientY);
    });

    document.addEventListener("mouseup", end);

    chat.addEventListener("touchstart", function (e) {
        const t = e.touches[0];
        start(t.clientX, t.clientY);
    }, { passive:false });

    document.addEventListener("touchmove", function (e) {
        if (!dragging) return;

        const t = e.touches[0];
        move(t.clientX, t.clientY);
        e.preventDefault();
    }, { passive:false });

    document.addEventListener("touchend", end);

    let prevState = isOpen();

    setInterval(() => {
        const nowOpen = isOpen();

        if (nowOpen !== prevState) {
            prevState = nowOpen;

            if (nowOpen) {
                applyOpenMode();
            } else {
                applyClosedMode();
            }
        }
    }, 150);

    return true;
}

const timer = setInterval(() => {
    if (initDragVS()) clearInterval(timer);
}, 1000);

})();